export default __webpack_public_path__ + "static/media/essentialWebsiteSample2.b6d2a820.png";